import invariant from 'tiny-invariant'

const MAYBE_GRAPHQL_SUBSCRIPTIONS_URL =
  process.env.NEXT_PUBLIC_GRAPHQL_SUBSCRIPTIONS_URL || process.env.VITE_GRAPHQL_SUBSCRIPTIONS_URL

invariant(
  MAYBE_GRAPHQL_SUBSCRIPTIONS_URL,
  'GRAPHQL_SUBSCRIPTIONS_URL must be set inside @repo/subscriptions',
)

export const GRAPHQL_SUBSCRIPTIONS_URL = MAYBE_GRAPHQL_SUBSCRIPTIONS_URL
